import LogRocket from 'logrocket';

import {ModifyState} from 'modules/modifier/types';

import {localStorageKey} from 'core/constants';
import {impersonationToken} from 'core/impersonation';
import {useAuthStore} from 'core/stores/auth';

export const getAuthorizationHeader = () => {
  const token = useAuthStore.getState().getToken();

  if (!token) {
    return null;
  }

  return {
    key: 'Authorization',
    value: `Bearer ${token}`,
  };
};

export const getFeatureOverridesHeader = () => {
  const storageSource = impersonationToken
    ? sessionStorage.getItem(localStorageKey.Modifiers)
    : localStorage.getItem(localStorageKey.Modifiers);
  const modifiedFlags: {state: ModifyState} = JSON.parse(storageSource || '{}');

  const modifiedFlagsValuesArr = Object.entries(modifiedFlags?.state?.featureFlags || []).map(
    ([name, {enabled}]) => `${name}=${enabled}`
  );
  const headerValue = modifiedFlagsValuesArr.join(';');

  if (!headerValue.length) {
    return null;
  }

  return {
    key: 'X-Ennabl-Feature-Overrides',
    value: headerValue,
  };
};

export const getLogRocketLinkHeader = () => {
  const sessionURL = LogRocket.sessionURL?.startsWith('https://') ? LogRocket.sessionURL : null;

  if (!sessionURL) {
    return null;
  }

  return {
    key: 'X-LogRocket-Session-URL',
    value: sessionURL,
  };
};
